export default "__VITE_ASSET__DxXar7IH__"